/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import styled, { css } from 'styled-components'
import { theme } from '~/styles'

interface TooltipCallProps {
  cursor?: string
}

export const TooltipCall = styled.span<TooltipCallProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: ${({ cursor }) => cursor || 'default'};
`

export const TooltipTemplate = styled.span`
  position: absolute;
  width: 100%;
  height: 100%;
`

interface ITooltipWrapper {
  show: boolean
  position?: 'top' | 'left' | 'right' | 'bottom'
  background?: string
  custom?: boolean
  opacity?: number
  isVisible?: boolean
  positionX: number
  positionY: number
  delay: number
  hasArrow?: boolean
  fullWidth?: boolean
  margin?: string
}

export const TooltipWrapper = styled.span<ITooltipWrapper>`
  border-radius: 6px;
  padding: ${({ custom, hasArrow }) => (hasArrow ? '0px 24px' : !custom ? '12px' : '0px')};
  margin: ${({ margin }) => margin};
  min-height: max-content;
  height: ${({ hasArrow }) => hasArrow && '34px'};
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'max-content')};

  transition: ${({ delay }) => `all ${delay}s ease-in`};
  background: ${props => (!props.background ? props.theme.colors.color2d3139 : props.background)};

  display: ${({ isVisible }) => (isVisible ? 'none' : 'flex')};
  align-items: center;
  justify-content: center;
  opacity: ${({ show, opacity }) => (show && !opacity ? '1' : show && opacity ? opacity : '0')};
  visibility: ${({ show }) => (show ? 'visible' : 'hidden')};

  max-width: 500px;
  overflow-wrap: break-word;
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
  z-index: 1000;

  position: absolute;
  top: ${({ positionY }) => positionY}px;
  left: ${({ positionX }) => positionX}px;
  ${({ position }) => {
    switch (position) {
      case 'bottom':
        return css`
          transform: translateY(50px);
        `
      case 'top':
      default:
        return css`
          transform: translateY(calc(-100% - 5px));
        `
    }
  }}
`

export const TooltipText = styled.span<{ textMaxWidth?: string }>`
  color: ${({ theme }) => theme.zds.colors.neutral1000};
  font-weight: 400;
  font-size: 14px;
  ${props =>
    props.textMaxWidth &&
    css`
      max-width: ${props.textMaxWidth};
    `}
`

const arrowPosition = (background: string | undefined) => ({
  bottom: css`
    bottom: 100%;
    border-bottom-color: ${background};
  `,
  top: css`
    top: 100%;
    border-top-color: ${background};
  `,
  right: css`
    right: 100%;
    border-right-color: ${background};
  `,
  left: css`
    left: 100%;
    border-left-color: ${background};
  `
})

interface ITooltipArrowProps {
  position?: 'top' | 'left' | 'right' | 'bottom'
  background?: string
}

export const TooltipArrow = styled.div<ITooltipArrowProps>`
  &:after {
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 5px;
    border-color: transparent;

    ${({ position, background }) =>
      position ? arrowPosition(background || theme.colors.color2d3139)[position] : 'display: none;'}

    ${({ position }) =>
      (position === 'left' || position === 'right') &&
      `
        top: 50%;
        margin-top: -5px;
      `}

    ${({ position }) =>
      (position === 'bottom' || position === 'top') &&
      `
        left: 50%;
        margin-left: -5px;
      `};
  }
`
